"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AperturaContacto() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section data-section-id="contacto-apertura" id="apertura-contacto" className="bg-background text-foreground py-24 md:py-32 lg:py-40 overflow-hidden">
      <div className="container mx-auto px-6 md:px-8 max-w-4xl">
        <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl font-normal text-foreground leading-[1.05] mb-10">
            Hablemos 30 minutos.
          </h1>

          <p className="font-sans text-lg md:text-xl text-foreground/90 leading-relaxed mb-8 max-w-3xl">
            Una llamada para entender tu operación, los dolores que estás viendo, y qué está sobre la mesa. Si hay fit, seguimos con propuesta de Diagnóstico en dos a tres días. Si no, te queda claridad sobre el siguiente paso.
          </p>

          <p className="font-serif italic text-2xl md:text-3xl text-primary leading-snug">
            Sin costo. Sin compromiso. Sin pitch.
          </p>
        </div>
      </div>
    </section>;
}